import { memo } from "react";
import styled from "styled-components";
import FilterTime from "./FilterTime";
function Title({ children = null, titleName = "" }) {
  return (
    <ContainerTilte>
      <h3 className="ui-sortable-handle">
        <div>
          {children} {titleName}
        </div>
        {/* <div>
          <FilterTime startDate={startDate} endDate={endDate} />
        </div> */}
      </h3>
    </ContainerTilte>
  );
}

export default memo(Title);
const ContainerTilte = styled.div`
  display: flex;
  align-items: center;
  background: #fff;
  min-height: 3rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  border-radius: 10px 10px 0 0;
  transition: background-color 0.4s ease-out;

  .ui-sortable-handle {
    cursor: move;
    margin-right: 0.66667rem;
    padding-left: 1rem;
    flex: 1;
    font-size: 15px;
    align-items: center;
    line-height: 3rem;
    color: #333;
    position: relative;
    font-weight: 500;
    display: flex;
    justify-content: space-between;

    :where(.css-dev-only-do-not-override-amq5gd).ant-picker {
      border: none;
    }
  }
`;
